import { FEATURE_FLAGS } from '../../../featureFlags';
import TasksList from './TasksList.vue';
import TaskDetails from './TaskDetails.vue';

const commonMeta = {
  featureFlag: FEATURE_FLAGS.TASKS,
  permissions: ['administrator', 'agent'],
};

export const routes = [
  {
    path: 'tasks',
    name: 'tasks_list',
    component: TasksList,
    meta: commonMeta,
  },
  {
    path: 'tasks/:taskId(\\d+)',
    name: 'task_details',
    component: TaskDetails,
    meta: commonMeta,
    props: route => ({ taskId: route.params.taskId }),
  },
];

export default routes;
